export const Goals = [
  'definition',
  'user_experience',
  'user_interface',
  'liquity',
  'retention',
  'monetization',
  'growth',
];
